module.exports = __webpack_public_path__ + "img/image-1.c8e82a4f.jpg";